import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pinIcon = (color) =>
  L.divIcon({
    className: "team-pin",
    html: `<span style="display:block;width:18px;height:18px;border-radius:50%;background:${color};border:3px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></span>`,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    popupAnchor: [0, -10],
  });

export default function TeamMap({ points = [] }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    mapRef.current = L.map(ref.current, { scrollWheelZoom: false }).setView([40.4168, -3.7038], 5);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(mapRef.current);
    layerRef.current = L.layerGroup().addTo(mapRef.current);
    setTimeout(() => mapRef.current?.invalidateSize(), 150);
    return () => { mapRef.current?.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current, layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    if (!points.length) return;
    const latlngs = [];
    points.forEach((p) => {
      const color = p.work_mode === "remote" ? "#7C3AED" : "#0EA5E9";
      const when = p.at ? new Date(p.at).toLocaleString("es-ES") : "";
      L.marker([p.lat, p.lng], { icon: pinIcon(color) })
        .addTo(layer)
        .bindPopup(
          `<b>${p.employee_name}</b><br/>${p.work_mode === "remote" ? "Teletrabajo" : "Presencial"}${p.open ? " · turno abierto" : ""}<br/><span style="color:#64748b">${when}</span>`
        );
      latlngs.push([p.lat, p.lng]);
    });
    if (latlngs.length === 1) map.setView(latlngs[0], 14);
    else map.fitBounds(latlngs, { padding: [40, 40], maxZoom: 15 });
    setTimeout(() => map.invalidateSize(), 100);
  }, [points]);

  return <div ref={ref} data-testid="team-map" style={{ height: 340, width: "100%", borderRadius: 12, zIndex: 0 }} />;
}
